import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Container, Row, Col, FormTextarea } from "shards-react";
import Moment from 'react-moment';
import Modal from 'react-bootstrap/Modal'
import BootstrapTable from 'react-bootstrap-table-next';

import { practiceEfectoresActions } from "../../core/practice-efectores";
import { practicePracticeEfectorVisitsActions, getCurrentPracticeEfectorVisits  } from "../../core/practice-efector-visits";
import { getEfectorById, efectorActions  } from "../../core/efectores";
import { specialtiesListActions, getCurrentSpecialtiesLists } from "../../core/specialties-lists";
import { getPracticeById } from "../../core/practices";
import { Store } from "../../flux";
import AdrressByLatLong from "../common/adrress-by-lat-lng"
import  loading_ajax from '../../images/oscilloscope.gif'
import LoadingIndicator from '../common/loading-indicator';

class EfectoresInternacionDetalleModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      comentarios: (props.visitas_efector) ? props.visitas_efector.comentarios : '',
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { user, authenticated, efectorId, practiceId, visits, show, efector, data } = nextProps

    if ( show && authenticated && user.sessionId && efectorId && practiceId && ( !visits || !visits.isPending  ) ) {
      this.props.loadVisits( new Map({ sessionId:user.sessionId, practiceId, efectorId }) )
    }
    if ( show && authenticated &&  efectorId && !efector ) {
      this.props.loadEfector(efectorId)
    }
  }

  handleSave() {
    const { user, authenticated, visitas_efector } = this.props
    const { comentarios } = this.state

    if (  authenticated && user.sessionId ){

      const _visita_efector = Object.assign(visitas_efector, {
        comentarios,
        sessionId:user.sessionId
      })

      this.props.updatePracticeEfector(_visita_efector)
    }

  }

  handleChange(key,event) {

    const { [key]: _value } = this.state
    const value = (event.target.validity.valid) ? event.target.value : _value;

    if ( value !== _value ) {
      this.setState({
          [key]: value
      });
    }
  }

  render() {
    const { show, efector,  efector_orden, visits, visitas_efector, specialties, isPending, comentarios, displayLoadingIndicator, practice } = this.props
    let readOnly = practice && practice.estado && practice.estado === "R"
    if (!show)
      return null

    let specialtie = null;

    if (specialties && efector)
      specialtie = specialties.items.find(specialtie => specialtie.id === efector.especialidadId )

      const columns = [
        {
          text: 'Nº',
          dataField: 'id',
          headerStyle: () => {
            return { width: "5%" };
          },
        },
        {
          isDummyField: true,
          text: '',
          dataField: 'dtUpdated',
          formatter: (cell, row ) => {
            return <span> Ingreso: <br/> Egreso: </span>
          },
          headerStyle: () => {
            return { width: "5%" };
          },
        },
        {
          text: 'Fecha',
          dataField: 'inicio',
          formatter: (cell, row ) =><span>
            { row.inicio !== '0001-01-01T00:00:00' ?
             <Moment date={row.inicio} format="DD/MM/YYYY" /> : ''
            }
            <br/>
            { row.inicio !== '0001-01-01T00:00:00' ?
             <Moment date={row.fin} format="DD/MM/YYYY" /> : ''
            }
          </span>,
          headerStyle: () => {
            return { width: "8%" };
          },
        },
        {
          text: 'Hora',
          dataField: 'fin',
          formatter: (cell, row ) => <span>
            { row.inicio !== '0001-01-01T00:00:00' ?
             <Moment date={row.inicio} format="H:mm" /> : ''
            }
            <br/>
            { row.inicio !== '0001-01-01T00:00:00' ?
             <Moment date={row.fin} format="H:mm" /> : ''
            }
          </span>,
          headerStyle: () => {
            return { width: "5%" };
          },
        },
        {
          text: 'Geolocalización',
          dataField: 'direccion',
          formatter: (cell, row) => <span>
            <AdrressByLatLong addressId={ `ingreso_${row.id}` } lat={ row.latInicio } lng={ row.longInicio } />
            <br/>
            <AdrressByLatLong addressId={ `egreso_${row.id}` } lat={ row.latFin } lng={ row.longFin } />
            </span>,
          headerStyle: () => {
            return { width: "36%" };
          },

        },
        {
          text: 'Observaciones',
          dataField: 'observaciones',
          headerStyle: () => {
            return { width: "40%" };
          },
        }
      ];

    return (
      <Modal
        dialogClassName="modal-lg"
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2500 }}
        onHide={() => this.props.handleClose() }
      >


      <Modal.Header closeButton className="border-0">
         <h5 className="m-0">
            <i className="far fa-user mr-2"></i> Efector { efector_orden } - <b> { efector ? (efector.nombre + ' ' + efector.apellido) : '' } </b>
         </h5>
       </Modal.Header>
       <Modal.Body className="pt-0" >
       <Container fluid className="main-content-container p-0">

        <Row className="mb-4">
           <Col>
           <Container fluid className="px-3 mb-4 pt-2 border-top bg-celeste detalle-header">
             <Row >
               <Col className="col-12 col-lg-2">
                 <Row>
                   <Col className="col-lg-12">
                     <label className="mb-0">Fecha de Asignación</label>
                     <h6><b>{ (visitas_efector && visitas_efector.fechaInicio !== '0001-01-01T00:00:00') ? <Moment date={visitas_efector.fechaInicio} format="DD/MM/YYYY" /> : '' }</b></h6>
                   </Col>
                   <Col className="col-lg-12">
                     <label className="mb-0">Fecha Hasta</label>
                     <h6><b>{ (visitas_efector && visitas_efector.fechaFin !== '0001-01-01T00:00:00') ?  <Moment date={ visitas_efector.fechaFin} format="DD/MM/YYYY" /> : '' }</b></h6>
                   </Col>
                 </Row>
               </Col>
               <Col className="col-12 col-lg-2">
                 <Row>
                   <Col className="col-lg-12">
                     <label className="mb-0">Teléfono 1</label>
                     <h6>{ efector ? efector.telefono1 : '' }</h6>
                   </Col>
                   <Col className="col-lg-12">
                     <label className="mb-0">Teléfono 2</label>
                     <h6>{ efector ? efector.telefono2 : '' }</h6>
                   </Col>
                 </Row>
               </Col>
               <Col className="col-12 col-lg-4">
                 <label className="mb-0">Especialidad</label>
                 <h6>{ specialtie ? specialtie.descripcion : '' }</h6>
               </Col>
               <Col className="col-12 col-lg-4">
                 <label className="mb-0">Comentario</label>
                 <FormTextarea ref={ e => this.input_comentarios = e} readOnly={readOnly} defaultValue={ visitas_efector ? visitas_efector.comentarios : ''} id="comentarios" onChange={this.handleChange.bind(this, 'comentarios')} />
                 <div className="btn-group-sm btn-group">
                  <button disabled={readOnly} className="btn text-secondary" onClick={this.handleSave.bind(this)}><i className="material-icons"></i></button>
                 </div>
               </Col>

             </Row>
               </Container>

             <Col className="col-md-3">
             <h6><b>Visitas</b></h6>
             </Col>
                { !isPending && <BootstrapTable keyField='id'
                  bordered={ false }
                  headerClasses="rdt_TableHead"
                  data={visits.items.toJS()}
                  columns={columns}
               /> }
               { isPending && <img className="d-table mx-auto mb-3"        src={loading_ajax}     alt="loading"
               /> }
               </Col>
           </Row>
           </Container>
        </Modal.Body>

      </Modal>
    );
  }
}

EfectoresInternacionDetalleModal.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,

};

EfectoresInternacionDetalleModal.defaultProps = {
  title: "Agregar Nuevo Efector",
  show: false,
};

//export default EfectoresInternacionDetalleModal;

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const efector = getEfectorById(state, `${props.efectorId}`)
  const specialties = getCurrentSpecialtiesLists(state, props)
  const visits = getCurrentPracticeEfectorVisits(state, props)
  const practice = getPracticeById(state, props.practiceId)

  let isPending = true;
  if ( visits )
    isPending = visits.isPending

  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    practiceId: props.practiceId,
    practice,
    efectorId: props.efectorId,
    visitas_efector: props.visitas_efector,
    visits,
    efector,
    specialties,
    isPending,
    displayLoadingIndicator: isPending
  };
};

const mapDispatchToProps = {
  loadVisits: practicePracticeEfectorVisitsActions.loadPracticeEfectorVisits,
  updatePracticeEfector: practiceEfectoresActions.updatePracticeEfector,
  loadEfector: efectorActions.loadEfector
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EfectoresInternacionDetalleModal);
